import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { PrestoCopySource } from 'app/model/pipeline/copysource/presto.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PrestoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class PrestoCopySourceAdapter extends CopySourceAdapter<PrestoCopySource, Model.PrestoSource> {
    protected override async _toResource(copySource: PrestoCopySource): Promise<Model.PrestoSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(PrestoCopySource).name);
    }

    protected override async _toModel(
        resource: Model.PrestoSource,
        copyActivity: CopyActivity
    ): Promise<PrestoCopySource> {
        return this._toTabularModel(resource, copyActivity, PrestoCopySource.MODEL);
    }
}
